import { CanceledError } from 'axios';
import { Dispatch, SetStateAction } from 'react';
import http from '../shared/HttpCommon';

const getLastSearchResult = async (
  searchHash: string,
  loading: Dispatch<SetStateAction<boolean>>,
  signal: AbortSignal
) => {
  try {
    loading(true);
    const { data } = await http.get(`/ai-search/search/${searchHash}/last`, {
      headers: { 'Content-Type': 'application/json' },
      signal,
    });
    loading(false);
    return data;
  } catch (error) {
    if (!(error instanceof CanceledError)) {
      loading(false);
      console.error(error);
    }
  }
};

const getAllSearchResults = async (
  searchHash: string,
  loading: Dispatch<SetStateAction<boolean>>,
  signal: AbortSignal
) => {
  try {
    loading(true);
    const { data } = await http.get(`/ai-search/search/${searchHash}`, {
      headers: { 'Content-Type': 'application/json' },
      signal,
    });
    loading(false);
    return data;
  } catch (error) {
    if (!(error instanceof CanceledError)) {
      loading(false);
      console.error(error);
    }
  }
};

const AiSearchService = {
  getLastSearchResult,
  getAllSearchResults,
};

export default AiSearchService;
